import React, {useEffect, useState} from 'react';
import styles from './Users.module.scss'

import {$t} from "../../../helpers/translator";
import {useHistory} from "react-router-dom";
import UsersTable from "../../../components/UsersTable/UsersTable";


const AdminUsers = (props) => {

    useEffect(() => {

    }, [])
    const history = useHistory();


    return (
        <div className={styles.container}>
            <div className={`${styles['row']} ${styles['flex-end']}`}>
                {/*<div className={'alma-button'}*/}
                {/*     onClick={(e) => goToVersionManagement(e)}>{$t('global.machines.versions.manageVersions')}*/}
                {/*</div>*/}
            </div>

            <UsersTable header={$t('global.users.allUsers')}/>
        </div>
    )
}

export default AdminUsers;
